import i18n from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import en from '../assets/locales/en.json';
import es from '../assets/locales/es.json';
import pt from '../assets/locales/pt.json';

type IProps = {
  children: React.ReactNode;
  language: string;
};

const getInstance = (language: string = 'en') => {
  const instanceI18n = i18n.createInstance();
  instanceI18n.use(initReactI18next).init({
    fallbackLng: language,
    resources: {
      en: { translation: { ...en } },
      es: { translation: { ...es } },
      pt: { translation: { ...pt } },
    },
    interpolation: {
      escapeValue: false,
      prefix: '{{',
      suffix: '}}',
    },
    returnNull: false,
  });
  return instanceI18n;
};

export const TranslationProvider = ({ children, language }: IProps) => {
  return (
    <I18nextProvider i18n={getInstance(language)} key={language}>
      {children}
    </I18nextProvider>
  );
};
